import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  marginLeft: {
    marginLeft: 4,
  },
  termContainer: {
    borderRadius: 4,
    backgroundColor: '#f3f3f3',
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: 8,
    width: '100%',
    marginTop: '0.3rem',
  },
}));
